import chatModule from '../chatModule';

function detailsScrollbar($log) {
    "ngInject";
    return {
        restrict: "A",
        scope: true,
        link: function (scope, element, attrs) {
            element.mCustomScrollbar({
                autoExpandScrollbar: false,
                scrollInertia: 5,
                contentTouchScroll: 1,
                mouseWheel: {
                    preventDefault: true
                }
            });
        }
    }
};

chatModule.directive("detailsScrollbar", detailsScrollbar);

export default detailsScrollbar;